import { SortDirection } from '@empathy/search-types';
import { COMPONENTS, DeepPartial, SortConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SORT_CONFIG: DeepPartial<SortConfig> = {
  components: {
    sort: COMPONENTS.PURE.SortDropdown,
    dropdown: {
      beforeItems: 'TuandcoClose'
    }

  },
  sorts:
    [
      {
        title: 'default',
        value: ''
      },
      {
        title: 'minPrice',
        value: 'priceSort asc',
        direction: SortDirection.ASC
      },
      {
        title: 'maxPrice',
        value: 'priceSort desc',
        direction: SortDirection.DESC
      },
      {
        title: 'nameAsc',
        value: 'name asc',
        direction: SortDirection.ASC
      },
      {
        title: 'nameDesc',
        value: 'name desc',
        direction: SortDirection.DESC
      }
    ]
};
export const DESKTOP_SORT_CONFIG: DeepPartial<SortConfig> = {
  components: {
    sort: COMPONENTS.PURE.SortDropdown,
    dropdown: {
      beforeItems: null
    }
  }

};
